/**
 * Questa è la classe per il Repository dell'autenticazione (Equipe)
 * Quindi tutte le richieste ai servizi che c'entrano con l'autenticazione' andrebbero messe qui
 *
 */
import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";

import { getResponseMessage, IBaseResponse } from "core/interfaces/data/Base";

import {
	ILoginRequest,
	ILogin,
	ISessionAuthResponse,
	IChangePasswordRequest,
	IResetPasswordRequest,
	ILoginResponse,
} from "core/interfaces/data/IAuthRequest";

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class AuthRepository {
	/**
	 * Metodo che fa il Login
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async Login(auth: ILoginRequest): Promise<ILogin> {
		let loginResult: ILogin;
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/Login`;

			const res = await axios.post<ILoginRequest, AxiosResponse<ILoginResponse>>(url, auth);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			loginResult = {
				logged: res.data.Result,
				nomeUtente: res.data.NomeUtente,
				cambiopasswordRichiesto: res.data.ChangePasswordFirstLogin,
			};
		} catch (err) {
			console.log(err);

			loginResult = { logged: false, nomeUtente: undefined, cambiopasswordRichiesto: false };
		}
		return loginResult;
	}

	// Verifica  se la sessione è ancora attiva altrimenti da errore 401
	async SessionCheckAuth() {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/CheckAuth`;

			const res = await axios.get<ISessionAuthResponse>(url);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return { IsLogged: res.data.Result, nomeUtente: res.data.NominativoUtente };
		} catch (err) {
			// console.log(err);

			return { IsLogged: false, nomeUtente: undefined };
		}
	}

	async Logout(): Promise<boolean> {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/Logout`;

			const res = await axios.get<IBaseResponse>(url);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return res.data.Result;
		} catch (err) {
			console.log(err);

			return false;
		}
	}

	async ChangePassword(props: IChangePasswordRequest, changePasswordToken: string | null): Promise<{ esito: boolean; message: string | undefined }> {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/ChangePassword`;
			var header;
			if (changePasswordToken)
				header = {
					headers: { ChangePasswordToken: changePasswordToken },
				};

			const res = await axios.post<IChangePasswordRequest, AxiosResponse<IBaseResponse>>(url, props, header);

			if (res.data.Errors) {
				throw new Error(getResponseMessage(res.data.Errors));
			}

			return { esito: res.data.Result, message: undefined };
		} catch (err: any) {
			console.log(err);

			return { esito: false, message: err.message };
		}
	}

	async ResetPassword(props: IResetPasswordRequest): Promise<{ esito: boolean; message: string | undefined }> {
		try {
			const url = `${window.CONFIG.REACT_APP_WS_HSB}/ResetPassword`;

			const res = await axios.post<IResetPasswordRequest, AxiosResponse<IBaseResponse>>(url, props);

			return { esito: res.data.Result, message: getResponseMessage(res.data.Errors) };
		} catch (err) {
			console.log(err);

			return { esito: false, message: undefined };
		}
	}
}
var  AuthRep=new AuthRepository()
export default  AuthRep;
